export default "__VITE_ASSET__Bn3vN8pW__"